 <template>
    <div class="page-container">

        <el-card style="margin-top: 20px;margin-bottom: 20px;">
            <div slot="header" class="clearfix">
                <span>Excel转账上传</span>
            </div>
            <div style="color: #00b7ee;font-weight: bolder;">&nbsp;&nbsp;&nbsp;&nbsp;普通Excel转账</div>
            <el-row>
                <el-col :span="24">
                <!--:http-request="excelUpload"-->
                    <el-upload
                            ref="upload"
                            :show-file-list="true"
                            accept=".xlsx"
                            action="/admin/excel/upload"
                            :on-success="fileUploadSuccess"
                            :on-error="fileUploadFail"
                            :auto-upload="false"
                            :limit="1"
                            :on-exceed="fileOnExceed"
                            :on-change="exceltran"
                            :before-remove="beforeRemoveExceltran"
                            style="margin-bottom: 30px;">
                        <el-button slot="trigger" size="small" type="primary">选取excel文件</el-button>
                    </el-upload>
                    <el-button size="small" style="margin-left:20px" type="success" @click="submitUpload">上传到服务器</el-button>
                    <el-button size="small" style="margin-left:20px" @click="downExecl" type="info">下载模板</el-button>
                </el-col>
                <el-col :span="24">
                    <div style="color:red;">{{seleExcelmsg}}</div>
                </el-col>
                <el-col :span="12">
                    <div v-for="item in excelResult" style="color: red">
                        <div>{{item}}</div>
                    </div>
                </el-col>
                <el-col v-if="excelData != 0" :span="24" style="margin-bottom:20px">
                    <el-table style="display:inline-block"
                        :data="tableData"
                    >
                        <el-table-column
                            :prop="item" :label="item" v-for="(item,index) in cehckboxTable" :key="index"
                        ></el-table-column>
                    </el-table>
                    <el-pagination  style="display:inline-block"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[7,10, 20, 50, 100]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </el-col>
            </el-row>
            <div style="color: #00b7ee;font-weight: bolder;">&nbsp;&nbsp;&nbsp;&nbsp;申购转账</div>
            <el-row>
                <el-col :span="24">
                    <!--  :http-request="purchaseExcelUpload" -->
                    <el-upload
                            ref="purchase"
                            :show-file-list="true"
                            accept=".xls,.xlsx"
                           
                            action="/admin/excel/upload/purchase"
                            :on-success="purchaseFileUploadSuccess"
                            :on-error="purchaseFileUploadFail"
                            :auto-upload="false"
                            :limit="1"
                            :on-exceed="fileOnExceed"
                            :on-change="apply"
                            :before-remove="beforeRemoveApply"
                            style="margin-bottom: 30px;">
                        <el-button slot="trigger" size="small" type="primary">选取excel文件</el-button>
                        
                    </el-upload>
                    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUploadPurchase">上传到服务器</el-button>
                    <el-button size="small" style="margin-left:20px" type="info" @click="downMoulds">下载模板</el-button>
                </el-col>
                <el-col :span="24">
                    <div style="color:red;">{{applymsg}}</div>
                </el-col>
                <el-col :span="12">
                    <div v-for="item in purchaseExcelResult" style="color: red">
                        <div>{{item}}</div>
                    </div>
                </el-col>
                <el-col v-if="excelDatas != 0" :span="24">
                    <el-table style="display:inline-block"
                        :data="tableDatas"
                    >
                        <el-table-column
                            :prop="item" :label="item" v-for="(item,index) in cehckboxTables" :key="index"
                        ></el-table-column>
                    </el-table>
                    <el-pagination style="display:inline-block"
                            @size-change="handleSizeChanges"
                            @current-change="handleCurrentChanges"
                            :current-page="currentPages"
                            :page-sizes="[7,10, 20, 50, 100]"
                            :page-size="pageSizes"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totals">
                    </el-pagination>
                </el-col>
            </el-row>
        </el-card>

        <el-card style="margin-top: 20px;margin-bottom: 20px;">
            <div slot="header" class="clearfix">
                <span>钱包户划转</span>
            </div>
            <el-form ref="walletForm" :model="walletTran" :rules="rules" label-width="200px">
                <el-form-item label="币种" prop="coinType">
                    <el-select v-model="walletTran.coinType" placeholder="请选择币种">
                        <el-option v-for="item in supportCoinDeposit" :key="item" :label="item"
                                   :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="到账用户(Tel/Email/UserId)" prop="username">
                    <el-input v-model="walletTran.username" disabled></el-input>
                </el-form-item>
                <el-form-item label="钱包类型" prop="walletType">
                    <el-select v-model="walletTran.walletType" placeholder="请选择">
                        <el-option v-for="item in walletTypes" :key="item.code" :value="item.code" :label="item.desc"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="充值金额" prop="availableBalanceChange">
                    <el-input-number v-model="walletTran.availableBalanceChange"></el-input-number>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="walletTran.remark"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="depositToWallet">确认充值</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <el-card style="margin-top: 20px;margin-bottom: 20px;">
            <div slot="header" class="clearfix">
                <span>内部划转</span>
            </div>
            <el-form ref="interForm" :model="internalTran" :rules="rules" label-width="200px">
                <el-form-item label="币种" prop="coinType">
                    <el-select v-model="internalTran.coinType" placeholder="请选择币种">
                        <el-option v-for="item in supportCoinTransfer" :key="item" :label="item" :value="item"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="到账用户(Tel/Email/UserId)" prop="toUsername">
                    <el-input v-model="internalTran.toUsername"/>
                </el-form-item>
                <el-form-item label="转账用户(Tel/Email/UserId)" prop="fromUsername">
                    <el-input v-model="internalTran.fromUsername"/>
                </el-form-item>
                <el-form-item label="钱包类型" prop="walletType">
                    <el-select v-model="internalTran.walletType" placeholder="请选择">
                        <el-option v-for="item in walletTypes" :key="item.code" :value="item.code" :label="item.desc"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="充值金额" prop="availableBalanceChange">
                    <el-input-number v-model="internalTran.availableBalanceChange"/>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="internalTran.remark"/>
                </el-form-item>
                <el-form-item label='是否展示账单'>
                    <template>
                        <el-radio-group v-model="internalTran.visible">
                            <el-radio :label="true">展示</el-radio>
                            <el-radio :label="false">不展示</el-radio>
                        </el-radio-group>
                    </template>
                </el-form-item>
                <el-form-item label="是否发送短信">
                    <el-switch v-model="internalTran.sendMsg" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
                <el-form-item label="短信内容" v-if="internalTran.sendMsg">
                    <el-input v-model="internalTran.sendNote"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="depositToInternal">确认充值</el-button>
                </el-form-item>
            </el-form>
        </el-card>

    </div>
</template>

<script>
    import http from '../../../plugins/axios.js';
    import './store';
    import {mapState, mapActions} from 'vuex';
    import api from "./api";
    import XLSX from 'xlsx'
    export default {
        name: 'airdropUpload',
        data() {
            return {
                seleExcel:{},
                aaplysele:{},
                seleExcelmsg:'',
                applymsg:'',
                tableData:[],
                excelData:[],
                cehckboxTable:[],
                currentPage:1,
                pageSize:7,
                total:0,
                tableDatas:[],
                excelDatas:[],
                cehckboxTables:[],
                currentPages:1,
                pageSizes:7,
                totals:0,
                supWalletCoin: '',
                supTranCoin: '',
                walletTran: {
                    availableBalanceChange: '',
                    coinType: '',
                    username: 'pingzhang@alpha.vip',
                    walletType:'WALLET',
                    remark:'',
                },
                internalTran: {
                    availableBalanceChange: '',
                    coinType: '',
                    fromUsername: '',
                    toUsername: '',
                    remark: '',
                    visible: false,
                    walletType:'WALLET',
                    sendMsg: false,
                    sendNote: '',
                },
                rules: {
                    availableBalanceChange: [{required: true, message: '请输入充值金额', trigger: 'blur'}],
                    coinType: [{required: true, message: '请输入充值币种', trigger: 'blur'}],
                    username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    fromUsername: [{required: true, message: '请输入到账用户', trigger: 'blur'}],
                    toUsername: [{required: true, message: '请输入转账用户', trigger: 'blur'}],
                    walletType:[{required: true, message: '请选择钱包类型', trigger: 'blur'}]
                },
                excelResult: [],
                purchaseExcelResult:{},
                walletTypes:[{code:'WALLET',desc:'现货账户'},{code:'OTC',desc:'法币账户'},{code:'CONTRACT',desc:'合约账户'},{code:'GENERAL',desc:'超级合约账户'}],//{code:'MARGIN',desc:'杠杆账户'}

            }
        },
        methods: {
            ...mapActions('airdropUpload', ['getSupportDepositCoinType', 'getSupportTransferCoinType', 'balanceChangeWallet', 'balanceChangeInternalTransfer']),   
            downExecl(){
                // console.log('23432')
                api.downExcel().then(res=>{
                    let blob = new Blob([res],{type:'application/vnd.ms-excel'});
                    let link = document.createElement('a');
                    link.style.display = 'none';
                    let objectUrl = URL.createObjectURL(blob);
                    link.href = objectUrl;
                    link.setAttribute('download','转账'+'.xlsx');
                    link.click();
                    URL.revokeObjectURL(objectUrl);
                })
            },
            downMoulds(){
                api.downPurchase().then(res=>{
                    let blob = new Blob([res],{type:'application/vnd.ms-excel'});
                    let link = document.createElement('a');
                    let objectUrl = URL.createObjectURL(blob);
                    link.href = objectUrl;
                    link.setAttribute('download','申购转账'+'.xlsx');
                    // link.download = '申购转账';
                    link.click();
                    URL.revokeObjectURL(objectUrl);
                })
            },
            apply(file,fileList){
                this.purchaseExcelResult = [];
                this.applymsg = '';
                this.aaplysele = file.raw;
                const fileReader = new FileReader();
                fileReader.onload = (ev) =>{
                    try{
                        const data = ev.target.result;
                        const workbook = XLSX.read(data,{
                            type:'binary'
                        });
                        let sheet = Object.keys(workbook.Sheets)[0];
                        const json = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
                        this.excelDatas= json;
                        this.tableDatas = json.slice(0,7);
                        let thead = Array.from(Object.keys(json[0])).map(
                            item => {
                                return item
                            }
                        )
                        this.totals = json.length;
                        this.cehckboxTables = thead.slice(0,9)
                    }catch(e){
                        console.log(e)
                    }
                }
                
                fileReader.readAsBinaryString(file.raw)
            },
            beforeRemoveExceltran(){
                this.excelData = []
            },
            beforeRemoveApply(){
                this.excelDatas = []
            },
            exceltran(file,fileList){
                this.seleExcel = file.raw;
                this.excelResult = [];
                this.seleExcelmsg = '';
                const fileReader = new FileReader();
                fileReader.onload = (ev) =>{
                    try{
                        const data = ev.target.result;
                        const workbook = XLSX.read(data,{
                            type:'binary'
                        });
                        let sheet = Object.keys(workbook.Sheets)[0];
                        const json = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
                        this.excelData = json;
                        this.tableData = json.slice(0,7);
                        let thead = Array.from(Object.keys(json[0])).map(
                            item => {
                                return item
                            }
                        )
                        this.total = json.length;
                        this.cehckboxTable = thead.slice(0,9)
                        console.log(this.cehckboxTable)
                    }catch(e){
                        console.log(e)
                    }
                }
                fileReader.readAsBinaryString(file.raw)
            },
            //申购转换分页
            handleSizeChanges(val){
                this.pageSizes = val;
                this.tableDatas = this.excelDatas.slice((this.currentPages-1)*val,(this.currentPages*val)-1);
            },
            handleCurrentChanges(val){
                this.currentPages = val;
                this.tableDatas = this.excelDatas.slice((val-1)*this.pageSizes,(val*this.pageSizes)-1);
            },
            //普通Excel分页
            handleSizeChange(val){
                this.pageSize = val;
                this.tableData = this.excelData.slice((this.currentPage-1)*val,(this.currentPage*val)-1);
            },
            handleCurrentChange(val){
                this.currentPage = val;
                this.tableData = this.excelData.slice((val-1)*this.pageSize,(val*this.pageSize)-1);
            },
            fileUploadSuccess() {
                /**上传成功清除列表*/
                this.$refs.upload.clearFiles();
                this.$message.success('上传成功');
            },
            purchaseFileUploadSuccess(){
                this.$refs.purchase.clearFiles();
                this.$message.success('上传成功');
            },
            fileUploadFail() {
                this.$refs.upload.clearFiles();
                this.$message.error('上传失败');
            },
            purchaseFileUploadFail(){
                this.$refs.purchase.clearFiles();
                this.$message.error('上传失败');
            },
            fileOnExceed() {
                this.$message('文件最大上传为1');
            },
            submitUpload() {
                this.excelUpload();
                // this.$refs.upload.submit();
            },
            submitUploadPurchase(){
                // this.$refs.purchase.submit();
                this.purchaseExcelUpload();
            },
            excelUpload(content) {
                // let data = content.file;
                if(JSON.stringify(this.seleExcel) == '{}'){
                    this.$message.warning("请选择Excel文件!")
                    return
                }
                let data = this.seleExcel;
                http.post({
                    url: '/admin/transfer/upload/excel',
                    data,
                    dataType: 'file'
                }).then((response) => {
                    if (response.code === 0) {
                        this.excelData = [];
                        this.seleExcelmsg = response.msg;
                        this.fileUploadSuccess();
                        this.excelResult = response.data;
                    } else {
                        this.fileUploadFail();
                    }
                });
            },

            purchaseExcelUpload(content) {
                // let data = content.file;
                if(JSON.stringify(this.aaplysele) == '{}'){
                    this.$message.warning("请选择Excel文件!")
                    return
                }
                let data = this.aaplysele;
                http.post({
                    url: '/admin/transfer/upload/excel/purchase',
                    data,
                    dataType: 'file'
                }).then((response) => {
                    if (response.code === 0) {
                        this.excelDatas = [];
                        this.applymsg = response.msg;
                        this.purchaseFileUploadSuccess();
                        this.purchaseExcelResult = response.data;
                    } else {
                        this.purchaseFileUploadFail();
                    }
                });
            },

            depositToWallet() {
                this.$refs['walletForm'].validate(valid => {
                    if (valid) {
                        this.balanceChangeWallet(this.walletTran).then(() => {
                            this.$message({type: 'success', message: '充值成功'});
                            this.$refs['walletForm'].resetFields();
                        })
                    }
                })
            },

            depositToInternal() {
                this.$refs['interForm'].validate(valid => {
                    if (valid) {
                        this.balanceChangeInternalTransfer(this.internalTran).then(() => {
                            this.$message({type: 'success', message: '充值成功'});
                            this.internalTran.toUsername = '';
                        })
                    }
                })
            },


        },

        computed: {
            ...mapState('airdropUpload', ['supportCoinDeposit', 'supportCoinTransfer'])
        },

        created() {
            this.getSupportDepositCoinType();
            this.getSupportTransferCoinType();
        }

    };
</script>

<style lang="less" scoped>
.el-col{
    display: -webkit-inline-box;
}
</style>
